/* istanbul ignore file */
import _ from 'underscore';
import 'jquery';
import IWindow, { type WindowInterface } from '@bingads-webui-clientcenter/window-interface';

import { getTimestampMillis } from './date-utils';

export interface PageLoadLogging {
  pageRoutePageLoadDuration?: (path: string, duration: number, recorded?: boolean) => void;
}

export interface PageLoadDurationOptions {
  logging?: PageLoadLogging;
  pageReadyMark: string;
}

export interface InstrumentedWindow extends WindowInterface {
  pageLoadDurationRecorded?: boolean;
  pageNavigationStartTime?: number;
  pageNavigationRecorded?: Record<string, boolean>;
  pageLandingPath?: string;
}

export const ScenarioNames = {
  agencyRequestsPage: 'AgencyRequestsPage',
  settingsPage: {
    content: 'SettingsContent',
    userInfo: 'SettingsUserInfoContent',
    emailNotification: 'SettingsEmailNotificationContent',
    billing: 'SettingsBillingContent',
    emailNotificationCategory: 'SettingsEmailNotificationCategoryContent',
    emailNotificationCategorySave: 'SettingsEmailNotificationCategorySave',
    emailNotificationCategoryAccountFetch: 'emailNotificationCategoryAccountFetch',
    emailNotificationCategoryAccountSelectorRender: 'emailNotificationCategoryAccountSelectorRender',
    emailNotificationCategoryAccountSelectAll: 'emailNotificationCategoryAccountSelectAll',
    emailNotificationCategoryAccountFilter: 'emailNotificationCategoryAccountFilter',
    emailNotificationUserSelectorRender: 'SettingsEmailNotificationUserSelectorRender',
  },
};

/**
 * Mark the page load time when page is loaded.
 * Log the page duration when page is navigated
 * @function
 * @param {logging} logging to log
 * @param {pageReadyMark} pageReadyMark which can be used for performance mark
  * @returns {void} Nothing
 */
export const logPageLoadAndNavigationDuration = ({
  logging,
  pageReadyMark
}: PageLoadDurationOptions) => {
  if ((IWindow as InstrumentedWindow).pageLoadDurationRecorded && (IWindow as InstrumentedWindow).pageNavigationStartTime && (IWindow as InstrumentedWindow).pageNavigationRecorded && logging && logging.pageRoutePageLoadDuration) {
    logging.pageRoutePageLoadDuration(IWindow.location.pathname, getTimestampMillis() - (IWindow as InstrumentedWindow).pageNavigationStartTime, (IWindow as InstrumentedWindow).pageNavigationRecorded[pageReadyMark]);
    (IWindow as InstrumentedWindow).pageNavigationRecorded[pageReadyMark] = true;
  }

  if (!(IWindow as InstrumentedWindow).pageLoadDurationRecorded && IWindow.location.pathname === (IWindow as InstrumentedWindow).pageLandingPath) {
    IWindow.performance.mark(`${pageReadyMark}LandingPageReady`);
    (IWindow as InstrumentedWindow).pageLoadDurationRecorded = true;
    (IWindow as InstrumentedWindow).pageNavigationRecorded = _.extend((IWindow as InstrumentedWindow).pageNavigationRecorded, { [pageReadyMark]: true });
  }
};
